
namespace SorAraBul.Definitions {
    export class TownsColumns {
        static columnsKey = 'Definitions.Towns';
    }
}